import { render, staticRenderFns } from "./Addtemplate.vue?vue&type=template&id=b0130404&scoped=true&"
import script from "./Addtemplate.vue?vue&type=script&lang=js&"
export * from "./Addtemplate.vue?vue&type=script&lang=js&"
import style0 from "./Addtemplate.vue?vue&type=style&index=0&id=b0130404&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0130404",
  null
  
)

export default component.exports